// Dark Mode Toggle Functionality
document.addEventListener("DOMContentLoaded", function() {
    const darkModeToggle = document.getElementById("dark-mode-toggle");
    const htmlElement = document.documentElement;
    // Check for saved theme preference or default to light mode
    const currentTheme = localStorage.getItem("theme") || "light";
    // Apply the saved theme
    if (currentTheme === "dark") {
        htmlElement.setAttribute("data-theme", "dark");
        darkModeToggle.innerHTML = '<i class="fa fa-sun-o"></i>';
    }
    // Toggle theme function
    function toggleTheme() {
        const currentTheme = htmlElement.getAttribute("data-theme");
        const newTheme = currentTheme === "dark" ? "light" : "dark";
        htmlElement.setAttribute("data-theme", newTheme);
        localStorage.setItem("theme", newTheme);
        // Update button icon
        if (newTheme === "dark") darkModeToggle.innerHTML = '<i class="fa fa-sun-o"></i>';
        else darkModeToggle.innerHTML = '<i class="fa fa-moon-o"></i>';
    }
    // Add click event listener
    darkModeToggle.addEventListener("click", toggleTheme);
});
// Smooth scrolling functions
function scrollToSection(sectionId) {
    const section = document.getElementById(sectionId);
    if (section) section.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
}
function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}

//# sourceMappingURL=repo.8242d811.js.map
